import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  postEmployerCreditsCall,
  postEmployerCreditsSummaryByCategoryCall,
  postEmployerCreditsHistoryCall,
  getEmployerCreditsCall,
  getEmployerCreditsHistoryCall,
} from './state';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  postEmployerCreditsCall.saga,
  postEmployerCreditsSummaryByCategoryCall.saga,
  postEmployerCreditsHistoryCall.saga,
  getEmployerCreditsCall.saga,
  getEmployerCreditsHistoryCall.saga,
];

export function* creditsSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
